import common from '@/util/common';
export default {
	name: 'common-nav',
	props: {
		name: {
			type: String,
		},
		navText: {
			type: String,
			default: ''
		},
		hasRightBtnFlag: {
			type: Boolean,
			default: false
		},
		path: {
			type: String,
			default: ''
		},
	},
	data() {
		return {

		}
	},
	created() {
		console.log('this.path',this.path)
	},
	methods: {
		goBack() {
			if (this.name) {
				common.jump(this, this.name);
			} else if (this.path) {
				common.jump(this, this.path, {}, 'query');
			} else {
				common.goBack(this);
			}
		},
		rightBtnHandle() {
			this.$emit('rightBtnHandle');
		}
	}
}
